import { fg } from '@atlaskit/platform-feature-flags/fg';

import { LEADERSHIP_CIRCLE_PROD_SUPPORT_SITE_HOSTNAME } from '../../constants/private';

/**
 * Determines whether citations should be removed from widget responses.
 *
 * Priority logic:
 * 1. If flag `csm_ai_enable_citations_in_widget` is true → show citations (return false)
 * 2. Fall back to existing hardcoded behaviour:
 *    - `csm-ai-remove-citations-in-widget` AND not Leadership Circle hostname
 *
 * NOTE: The hardcoded `csm-ai-remove-citations-in-widget` flag remains as a safety net
 * to prevent citation leakage if Statsig fails.
 */
export const isRemoveCitationsEnabled = (): boolean => {
	// Priority 1: Override flag enables citations (returns false to NOT remove them)
	if (fg('csm_ai_enable_citations_in_widget')) {
		return false;
	}

	// Priority 2: Fall back to existing hardcoded behaviour
	return (
		fg('csm-ai-remove-citations-in-widget') &&
		window.location.hostname !== LEADERSHIP_CIRCLE_PROD_SUPPORT_SITE_HOSTNAME
	);
};
